const en = {
  login: {
    subtitle: 'Client portal',
    title: 'Log in',
    server: 'Server',
    serverPlaceholder: 'organization-name',
    checking: 'Checking...',
    notFound: 'Organization not found',
    phone: 'Phone',
    phonePlaceholder: '90 123 45 67',
    password: 'Password',
    submit: 'Log in',
    submitting: 'Logging in...',
  },
  catalog: {
    searchPlaceholder: 'Search products...',
    allFolders: 'All',
    notFound: 'Not found',
    empty: 'This folder is empty',
    noPrice: 'No price',
    addToCart: "Add",
    chooseUnit: "Choose unit",
    selected: "selected",
    done: "Done",
    doneRemovesAll: "Setting all to 0 removes it from the cart",
  },
  cart: {
    title: 'Cart',
    empty: 'Cart is empty',
    goCatalog: 'Go to catalog',
    myOrders: 'My orders',
    notePlaceholder: 'Note (optional)',
    total: 'Total',
    submit: 'Place order',
    submitting: 'Sending...',
    orderSent: 'Order #{number} sent',
    orderError: 'Failed to send order',
  },
  orders: {
    title: 'My orders',
    empty: 'No orders yet',
  },
  changePassword: {
    title: 'Set a new password',
    hint: 'For security, you need to change the default password. You will only be asked once.',
    newPassword: 'New password',
    confirmPassword: 'Confirm new password',
    tooShort: 'Password must be at least 4 characters',
    mismatch: 'Passwords do not match',
    submit: 'Save',
    submitting: 'Saving...',
    success: 'Password updated',
    error: 'Something went wrong',
  },
  profile: {
    changePassword: "Change password",
    cancel: "Cancel",
  },
  home: {
    defaultTitle: 'Client portal',
    welcome: 'Welcome,',
    balance: 'Balance',
    noBalance: 'No balance available',
    weOwe: 'We owe you',
    theyOwe: 'Outstanding debt',
    cashback: 'Cashback',
    cashbackProgramTitle: 'Cashback program',
    cashbackProgramHint: 'The bigger your purchase, the higher the percentage back',
    cashbackCurrentTier: 'You are currently here',
    navHome: 'Home',
    navCatalog: 'Catalog',
    navCart: 'Cart',
    navAkt: 'Statement',
    navProfile: 'Profile',
    logout: 'Log out',
  },
  aktSverka: {
    title: 'Reconciliation statement',
    period: 'Period',
    fromDate: 'From',
    toDate: 'To',
    youOwe: 'You owe',
    theyOwe: 'They owe you',
    noDebt: 'No outstanding debt',
    noTx: 'No transactions in this period',
    opening: 'Opening balance',
    loadError: 'Failed to load',
    itemsEmpty: 'No items',
    total: 'Total',
    close: 'Close',
    share: 'Share',
    shareTitle: 'Permanent link',
    shareHint: 'Use this link/QR code to view your statement anytime — e.g. send it to your accountant.',
    copy: 'Copy',
    copied: 'Copied',
    qrDownload: 'Download',
    thDate: 'Date', thDoc: 'Document', thDebit: 'Debit', thCredit: 'Credit',
    pdfDownload: 'PDF',
  },
  uomNames: {
    pcs: "Piece", kg: "Kilogram", g: "Gram", t: "Ton", l: "Liter", ml: "Milliliter",
    m: "Meter", cm: "Centimeter", mm: "Millimeter", "m²": "Square meter", "m³": "Cubic meter", km: "Kilometer",
    pair: "Pair", roll: "Roll", box: "Box", pack: "Package", bag: "Bag", set: "Set",
    bottle: "Bottle", can: "Can", cyl: "Cylinder", coil: "Coil", spool: "Spool", sheet: "Sheet", bunch: "Bunch",
    hr: "Hour", min: "Minute", day: "Day", week: "Week", month: "Month", year: "Year",
    visit: "Visit", session: "Session", project: "Project", page: "Page", word: "Word", trip: "Trip",
  },
};
export default en;
